import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export const PANEL_ADMIN_USERS: string[] = [
  '35e38f76-3555-414b-a1a0-a8ae992ee47f',
  '1b8ff2e1-a762-4266-8da3-6873ba78b862',
  '3879d37d-3658-48a6-b24b-24e8a8eb77c6',
];

const PANEL_AUTH_KEY = 'panel:auth';

const PanelRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  const hasLocalFlag = (() => {
    try { return localStorage.getItem(PANEL_AUTH_KEY) === 'true'; } catch { return false; }
  })();

  const isAllowed = !!user && PANEL_ADMIN_USERS.includes(user.id);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center space-y-2">
          <div className="animate-pulse text-slate-500">Cargando...</div>
        </div>
      </div>
    );
  }

  if (!(hasLocalFlag && isAllowed)) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/panel/login?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
};

export default PanelRoute;